import { inject, Service } from '@angular/core';
import { HttpService } from '@data-services/http/http.service';
import { MBECompany } from './mbe-company.model';

@Service()
export class MbeCompanyDataService {
  private readonly http = inject(HttpService);

  async getMbeCompaniesAsync(): Promise<MBECompany[]> {
    return await this.http.getObjectAsync<MBECompany[]>('mbecompanies');
  }
}
